<div>
  @if (subscribed()) {
    <div class="flex items-center gap-2 text-white py-3">
      <i class="pi pi-check-circle" style="color: #4ade80; font-size: 1.25rem"></i>
      <span>{{ 'layout.newsletter.success' | translate }}</span>
    </div>
  } @else {
    <div class="flex gap-3 flex-column xl:flex-row">
      <input [formControl]="newsletterEmail" class="flex-1" type="email" pInputText [placeholder]="'layout.newsletter.placeholder' | translate" />
      <app-button
        (click)="subscribeToNewsletter()"
        [shadow]="true"
        [color]="buttonColor"
        size="m-large"
        [fullWidth]="true"
        [label]="'layout.newsletter.button' | translate"
        [disabled]="newsletterEmail.invalid"
        [isLoading]="subscribingToNewsletter()">
      </app-button>
    </div>
    <div class="mt-2">
      <app-form-error-display [control]="newsletterEmail"></app-form-error-display>
    </div>
  }
</div>
